import { recoverCustomer } from "@app/lib/authentication";
import { Error } from "@app/types/misc";
import { recoverPasswordErrorMessage } from "@app/utils/authentication";

document.addEventListener("DOMContentLoaded", () => {
  initForm();

  // Back to login button
  const $loginButton: HTMLButtonElement | null = document.querySelector(".button-back-to-login");
  if ($loginButton) {
    $loginButton.addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent("drawer:password-recover:close"));
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("drawer:login:open"));
      }, 300);
    });
  }
});

const initForm = () => {
  const $form: HTMLFormElement | null = document.querySelector("#password-recover form");
  if (!$form) return;

  const $submitButton: HTMLButtonElement | null = $form.querySelector("button[type='submit']");
  const $emailInput: HTMLInputElement | null = $form.querySelector("input[name='customer[email]']");
  if (!$submitButton || !$emailInput) return;

  const $emailInputWrapper: HTMLDivElement | null = $emailInput.closest(".snippet-input");
  if (!$emailInputWrapper) return;

  $emailInput.addEventListener("keyup", (e) => {
    if (e.key === "Enter") {
      $submitButton.click();
    }
  });

  $form.addEventListener("submit", async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    cleanInputError($emailInputWrapper);

    const email = $emailInput.value;
    $submitButton.disabled = true;
    const error = await submitForm(email);

    if (error) {
      inputError($emailInputWrapper, error);
      $submitButton.disabled = false;
    } else {
      document.dispatchEvent(new CustomEvent("drawer:password-recover:close"));
      document.dispatchEvent(new CustomEvent("drawer:login:open", { detail: { isPasswordRecover: true, email } }));
    }
  });
};

const submitForm = async (emailValue: string) => {
  const email = (emailValue || "").trim();

  let error: Error | null = null;

  if (!email) {
    error = { field: "email", message: "Enter your email" };
    return error;
  }

  const res = await recoverCustomer({ email });

  if (res.customerUserErrors.length > 0) {
    error = {
      ...res.customerUserErrors[0],
      ...(res.customerUserErrors[0].field && {
        field: res.customerUserErrors[0].field[res.customerUserErrors[0].field.length - 1],
      }),
    };
    return error;
  }
};

const inputError = ($inputWrapper: HTMLDivElement, error: Error) => {
  const $helperText: HTMLDivElement | null = $inputWrapper.querySelector(".helper-text");
  if (!$helperText) return;
  $inputWrapper.classList.add("snippet-input--error");

  let errorMessage = error.message;

  if (error.code && recoverPasswordErrorMessage[error.code]) {
    errorMessage = recoverPasswordErrorMessage[error.code];
  }

  $helperText.innerText = errorMessage;

  $helperText.classList.remove("hidden");
};

const cleanInputError = ($inputWrapper: HTMLDivElement) => {
  const $helperText: HTMLDivElement | null = $inputWrapper.querySelector(".helper-text");
  if (!$helperText) return;
  $inputWrapper.classList.remove("snippet-input--error");
  $helperText.classList.add("hidden");
};
